/**
 * Display formatting for `franchiseCount` dynamic replacements (e.g. {{ franchiseCount }}).
 * Source values may be a number, numeric string, JSON string from GetAccurateFranchiseCount, or CMS dynamic_parameter.
 */

export function formatFranchiseCountForDisplay(raw: unknown): string {
    if (raw === null || raw === undefined) {
        return '';
    }

    if (typeof raw === 'number') {
        if (!Number.isFinite(raw)) {
            return String(raw);
        }
        return raw.toLocaleString('en-US');
    }

    if (typeof raw === 'string') {
        const digits = raw.replace(/,/g, '').trim();
        if (!digits) {
            return '';
        }
        const parsed = Number(digits);
        if (!Number.isFinite(parsed)) {
            return raw;
        }
        return parsed.toLocaleString('en-US');
    }

    if (typeof raw === 'object') {
        const record = raw as Record<string, unknown>;
        const nested = record.franchiseCount
            ?? record.count
            ?? record.FranchiseCount
            ?? record.value;
        if (nested !== undefined) {
            return formatFranchiseCountForDisplay(nested);
        }
    }

    return String(raw);
}

type VariablesWithFranchiseCount = Record<string, string | number | string[]>;

/** Ensures `franchiseCount` is a comma-formatted display string when present in a variable map. */
export function applyFranchiseCountFormatting<T extends VariablesWithFranchiseCount>(variables: T): T {
    if (!Object.prototype.hasOwnProperty.call(variables, 'franchiseCount')) {
        return variables;
    }
    const { franchiseCount, ...rest } = variables;
    return {
        ...rest,
        franchiseCount: formatFranchiseCountForDisplay(franchiseCount),
    } as unknown as T;
}
